// Icon names (core/Icon `value`) used across the select's sub-parts.
export const SELECT_DROPDOWN_ICON = {
    CHEVRON: 'chevron-down',
    CHECK: 'check',
    CLEAR: 'x-close',
    REMOVE: 'x-close',
    CREATE: 'plus',
};

// Control sizes: sm 30px / md 33px / lg 36px. lg is the default — the 36px
// field is the design baseline (and what the Alpaca select2 skin renders);
// sm/md step it down while the menu keeps the one design look.
export const SELECT_DROPDOWN_SIZE = {
    SM: 'sm',
    MD: 'md',
    LG: 'lg',
};

export const SELECT_DROPDOWN_SIZES = new Set(Object.values(SELECT_DROPDOWN_SIZE));

// Control skins. `default` is the original DS control (label above the box);
// `soft` is the softbox design — @radius-lg box with the label INSIDE on its
// own small first line (56/52/48px per size). The menu is identical in both.
export const SELECT_DROPDOWN_VARIANT = {
    DEFAULT: 'default',
    SOFT: 'soft',
};

export const SELECT_DROPDOWN_VARIANTS = new Set(Object.values(SELECT_DROPDOWN_VARIANT));

// Token used inside `createTagFormat` — replaced with the typed term
// (same contract as legacy/core/SelectDropdown).
export const SELECT_DROPDOWN_CREATE_TAG_TERM = '{term}';

// Default `createTagFormat`: the create row is labelled with the raw term.
export const SELECT_DROPDOWN_DEFAULT_CREATE_TAG_FORMAT = SELECT_DROPDOWN_CREATE_TAG_TERM;

// Debounce for the `onSearch` callback (matches the legacy React wrapper's
// ajax delay).
export const SELECT_DROPDOWN_SEARCH_DEBOUNCE_MS = 300;

// z-index for the portalled menu. react-select sets the portal's inline styles,
// so the value has to reach it through JS rather than from LESS.
// Keep in sync with @select2-z-index in less/variables.less — asserted by
// SelectDropdown.test.jsx, which reads that file.
export const SELECT_DROPDOWN_PORTAL_Z_INDEX = 1032;

// Default cap for the menu width (px). The menu grows to fit its options up to
// this; override per call site with the `menuWidth` prop. Keep in sync with
// @select-dropdown-menu-max-width in index.less — asserted by SelectDropdown.test.jsx.
export const SELECT_DROPDOWN_MENU_MAX_WIDTH = 480;
